// import { IResourceComponentsProps } from "@refinedev/core";
// import { MuiCreateInferencer } from "@refinedev/inferencer/mui";

// export const ContainerCreate: React.FC<IResourceComponentsProps & { onClose: () => void }> = ({ onClose }) => {
//     return (
//         <MuiCreateInferencer
//             fieldTransformer={(field: any) => {
//                 if (["locale", "updatedAt", "publishedAt"].includes(field.key)) {
//                     return false;
//                 }

//                 return field;
//             }}
//         />
//     );
// };

import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import { useGetIdentity, useTranslation } from "@refinedev/core";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { FC } from "react";
import { Controller } from "react-hook-form";

export enum ContainerTypes {
  GAJOU = "gajou",
  LAMA = "lama",
}

export const ContainerCreate: FC<{ onClose?: () => void }> = ({
  onClose,
}): JSX.Element => {
  const { translate } = useTranslation();

  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    control,
    formState: { errors },
  } = useForm();
  const { data: user } = useGetIdentity<{
    name: string;
    avatar: any;
    id: any;
  }>();
  const userId = user && user.id;

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <FormControl sx={{ mt: -1, display: "none" }}>
          <TextField
            type="hidden"
            {...register("user", {
              required: translate("this-field-is-required"),
            })}
            error={!!(errors as any)?.user}
            helperText={(errors as any)?.user?.message}
            margin="normal"
            value={userId}
            InputLabelProps={{ shrink: true }}
            name="user"
          />
        </FormControl>
        <TextField
          {...register("name", {
            required: translate("this-field-is-required"),
          })}
          error={!!(errors as any)?.name}
          helperText={(errors as any)?.name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Name"
          name="name"
        />
        <TextField
          {...register("quantity", {
            required: translate("this-field-is-required"),
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.quantity}
          helperText={(errors as any)?.quantity?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Quantity"
          name="quantity"
        />
        <Controller
          control={control}
          name="type"
          rules={{ required: translate("this-field-is-required") }}
          // eslint-disable-next-line
          defaultValue={null as any}
          render={({ field }) => (
            <Select
              {...field}
              variant="outlined"
              label="Container Type"
              sx={{ mt: 1 }}
            >
              {Object.keys(ContainerTypes).map((item, index) => {
                console.log({ item });
                return (
                  <MenuItem value={item} key={index}>
                    {item}
                  </MenuItem>
                );
              })}
            </Select>
          )}
        />
        <Controller
          control={control}
          name="is_used"
          // eslint-disable-next-line
          defaultValue={null as any}
          render={({ field }) => (
            <FormControlLabel
              label="Is Used"
              control={
                <Checkbox
                  {...field}
                  checked={field.value}
                  onChange={(event) => {
                    field.onChange(event.target.checked);
                  }}
                />
              }
            />
          )}
        />
      </Box>
    </Create>
  );
};
